import React from "react";
import { FaAward } from "react-icons/fa";
import { FiActivity } from "react-icons/fi";
import { MdOutlineFolderSpecial } from "react-icons/md";
import ME from "../../assets/me-about.jpg";
import "./about.css";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <div className="flex justify-center items-center">
                <MdOutlineFolderSpecial className="about__icon" />
              </div>
              <h5>Projects</h5>
              <small>50+ School Projects</small>
              <div></div>
              <small>10+ Personal Projects</small>
            </article>
            <article className="about__card">
              <div className="flex justify-center items-center">
                <FaAward className="about__icon" />
              </div>

              <h5>Education</h5>
              <small>Pursuing Bachelor's in Computer Science</small>
            </article>
            <article className="about__card">
              <div className="flex justify-center items-center">
                <FiActivity className="about__icon" />
              </div>
              <h5>Interests</h5>
              <small>Video Games</small>
              <div></div>
              <small>Solving Puzzle</small>
            </article>
          </div>
          <p>
            Hi there, I'm Nam Tran, but feel free to call me Henry.
            <br />
            Programming has captivated my attention with its limitless potential
            to create, innovate, and solve intricate puzzles through lines of
            code.
            <br />
            The thrill of crafting solutions that seamlessly transform complex
            problems into elegant algorithms is what truly ignites my passion.
            <br />
            Every programming challenge I encounter becomes an opportunity to
            dive into the depths of logic and creativity, constantly pushing the
            boundaries of what I can achieve.
            <br />
            With each project, I find myself immersed in a world of endless
            learning, where every keystroke brings me closer to mastering the
            art of instructing machines to bring imagination to life.
          </p>

          <a href="#contact" className="btn btn-primary" id="AboutTalk">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
